/**
 * Validacao de placa de veiculo — formato antigo (ABC1234) e Mercosul (ABC1D23).
 *
 * Mesma regra do protótipo, e ela precisa continuar batendo com as funcoes SQL
 * `normalizar_placa`/`validar_placa` do banco quando essa camada existir.
 */

const REGEX_ANTIGA = /^[A-Z]{3}[0-9]{4}$/;
const REGEX_MERCOSUL = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;

/** Caixa alta, sem hifen, espaco ou ponto. */
export function normalizarPlaca(placa: string | null | undefined): string {
  if (!placa) {
    return '';
  }
  return placa.toUpperCase().replace(/[\s\-.]/g, '');
}

/** Vazia conta como valida — e o estado de rascunho, antes de a pessoa digitar. */
export function validarPlaca(placa: string | null | undefined): boolean {
  const normalizada = normalizarPlaca(placa);
  if (!normalizada) {
    return true;
  }
  return REGEX_ANTIGA.test(normalizada) || REGEX_MERCOSUL.test(normalizada);
}

export const MENSAGEM_DE_PLACA_INVALIDA =
  'Placa inválida — use o formato antigo ABC-1234 ou o Mercosul ABC-1D23.';
